import { cn } from '@/lib/cn';

type Tone = 'success' | 'warning' | 'danger' | 'info' | 'muted' | 'accent';

const STATUS_TONE: Record<string, Tone> = {
  ACTIVE: 'success',
  ONLINE: 'success',
  COMPLETED: 'success',
  SUCCESS: 'success',
  PAID: 'success',
  APPROVED: 'success',
  SENT: 'success',
  ENABLED: 'success',

  PENDING: 'warning',
  IDLE: 'warning',
  STALE: 'warning',
  RUNNING: 'warning',
  DRAFT: 'warning',
  SCHEDULED: 'warning',
  IN_PROGRESS: 'warning',

  QUEUED: 'info',
  PROCESSING: 'info',

  FAILED: 'danger',
  ALERT: 'danger',
  REVOKED: 'danger',
  SUSPENDED: 'danger',
  CRITICAL: 'danger',
  ERROR: 'danger',
  CANCELLED: 'danger',
  CANCELED: 'danger',

  OFFLINE: 'muted',
  INACTIVE: 'muted',
  ARCHIVED: 'muted',
  DISABLED: 'muted',

  MAINTENANCE: 'accent',
};

const TONE_CLASS: Record<Tone, string> = {
  success: 'pill-success',
  warning: 'pill-warning',
  danger: 'pill-danger',
  info: 'pill-info',
  muted: 'pill-muted',
  accent: 'pill-accent',
};

interface StatusPillProps {
  status: string;
  tone?: Tone;
  className?: string;
}

export function StatusPill({ status, tone, className }: StatusPillProps) {
  const resolved: Tone = tone ?? STATUS_TONE[status.toUpperCase()] ?? 'muted';
  return <span className={cn(TONE_CLASS[resolved], className)}>{status}</span>;
}
